module.exports = __webpack_public_path__ + "media/images/badges/yogasix/active/Y6Warrior2022_Badges_3000_Active@1x-4709b8ab42a75aaf7132437db1316b6d.png";